import React from 'react';

import {
  ScrollFadeContent,
  ScrollFadeViewport,
} from '@/shared/components/ui/scroll-fade/scroll-fade.styled';
import { TScrollFadeProps } from '@/shared/components/ui/scroll-fade/scroll-fade.types';
import { useScrollFade } from '@/shared/components/ui/scroll-fade/use-scroll-fade/use-scroll-fade';

export const ScrollFade: React.FC<TScrollFadeProps> = ({
  children,
  maxHeight,
  gap = '0',
  className,
}) => {
  const { ref, fadeTop, fadeBottom } = useScrollFade();

  return (
    <ScrollFadeViewport
      ref={ref}
      className={className}
      $maxHeight={maxHeight}
      $fadeTop={fadeTop}
      $fadeBottom={fadeBottom}
    >
      <ScrollFadeContent $gap={gap}>{children}</ScrollFadeContent>
    </ScrollFadeViewport>
  );
};
